export const userActivity = {
  methods: {
    userActivityMap(item) {
      const map = {
        login: 'Login',
        successful: 'Successful'
      }

      return map.hasOwnProperty(item) ? map[item] : '';
    }
  }
}